import React, { memo, useState } from 'react';
import { isMobile } from 'react-device-detect';
import { Form } from 'react-bootstrap';
import { DEMO_USER_PICTURE } from '../../../../common/common';
import LazyImage from '../../../../components/CustomLibraries/LazyImage';
import { BsUpload, FiCamera, IoIosArrowBack } from '../../../../components/icons';
import { toast } from 'react-toastify';
import appConfig from '../../../../config/config';

const {
  socialLinks: { privacyPolicy, termsAndConditions }
} = appConfig;
// const DEFAULT_COVER_ARRAY = [
//   'upload/photos/2022/12/doctube_dev/x1RGOnO5lfAYKuRevEga_09_8f589606b0618563f4afbde94955a2f1_blob',
//   'upload/photos/2022/12/doctube_dev/9YfpfxJmQodM5LrG4UIa_09_f780248a566e4f554386d393ba3ef30c_blob'
// ];
const base = 'upload/photos/';
const DEFAULT_COVER_ARRAY = [1, 2].map((_i) => `${base}doctube_channel_cover_${_i}.jpg`);
const CoverImgSelectionForm = ({
  onNextBtnClick,
  onUpload,
  onDefaultSelect,
  selectedCoverPicture,
  registerChannel
}) => {
  const [isChecked, SetIsChecked] = useState(true);
  return (
    <>
      <div className="col-12 shareLoginV2FormRow dt_steps dt_ProfileManagement p-0 posiiton-relative">
        <div className="dt_step_panel">
          <h2 className="text-black fw-medium fs-16 mb-5 text-center">
            Choose a cover picture! This will be prominently displayed on your channel page.
            <span className="mx-auto d-block rounded bg-primary dt_stepTextBtmBorder mt-3"></span>
          </h2>

          <div className="dt_step_form mx-auto mw-100">
            {selectedCoverPicture && (
              <div className="dt_coverPic_preview rounded-3 overflow-hidden mb-4 w-100">
                <LazyImage
                  src={
                    typeof selectedCoverPicture == 'object'
                      ? URL.createObjectURL(selectedCoverPicture)
                      : selectedCoverPicture
                  }
                  className="object-fit-cover w-100 h-100 float-start"
                  fallback_image={DEMO_USER_PICTURE}
                />
              </div>
            )}

            <form action="">
              <div className="d-flex dr_ImageSelectBtn mb-4">
                {isMobile && (
                  <button
                    className="rounded-3 flex-1 d-flex align-items-center justify-content-center fs-4 btn btn-primary fw-medium me-4 px-2 py-4 uploadPicBtn position-relative"
                    type="button"
                  >
                    <input
                      className="position-absolute top-0 start-0 w-100 h-100 rounded-circle bg-danger z-3 opacity-0"
                      type="file"
                      id="imageFile"
                      capture="user"
                      accept="image/*"
                      onClick={(e) => {
                        e.target.value = '';
                      }}
                      onChange={onUpload}
                    />
                    <FiCamera customClass="fs-3  me-2" /> Take a photo
                  </button>
                )}

                <button
                  className="rounded-3 flex-1 d-flex align-items-center justify-content-center fs-4 btn btn-primary fw-medium ms-0 px-2 py-4 uploadPicBtn position-relative"
                  type="button"
                >
                  <input
                    className="position-absolute top-0 start-0 w-100 h-100 rounded-circle bg-danger z-3 opacity-0"
                    type="file"
                    id="imageFile"
                    accept="image/*"
                    onChange={onUpload}
                    onClick={(e) => {
                      e.target.value == '';
                    }}
                  />
                  <BsUpload customClass="fs-3 text-white me-2" />
                  Upload photo
                </button>
              </div>
              <h4 className="fs-4 text-black fw-medium mb-4 text-center">
                <span className="d-block text-center mb-2">OR</span>
                <span className="d-block text-center">you can pick one of ours!</span>
              </h4>

              {/* Cover img Start */}
              <div className="d-flex dt_defaultImg_selection dt_coverImg justify-content-center mb-4 gap-4">
                {DEFAULT_COVER_ARRAY?.map((_cover, _idx) => (
                  <div className="dt_imgBtn flex-1">
                    <div className="dt_imgBtnIn rounded-3 position-relative overflow-hidden">
                      <input
                        className="position-absolute top-0 start-0 w-100 h-100 opacity-0 z-3 cursorPointer"
                        type="radio"
                        value={_cover}
                        name="options"
                        id={`avatar${_idx + 1}`}
                        checked={selectedCoverPicture == _cover}
                        onChange={(e) => {
                          onDefaultSelect(_cover);
                        }}
                      />
                      <label
                        className="position-relative border-0 p-0 rounded-3 overflow-hidden w-100"
                        htmlFor={`avatar${_idx + 1}`}
                      >
                        <LazyImage
                          src={_cover}
                          alt="Select Image"
                          className="object-fit-cover w-100 h-100 float-start position-absolute top-0 start-0"
                        />
                        <div className="overlay"></div>
                      </label>
                    </div>
                  </div>
                ))}
              </div>
              {/* Cover img end */}
              <div className="w-100 mt-5 d-flex">
                <Form.Check
                  id="tnc"
                  type={'checkbox'}
                  checked={isChecked}
                  onChange={() => {
                    SetIsChecked(!isChecked);
                  }}
                  label="I Accept"
                />
                <a
                  className="d-inline-block ms-3 text-secondary"
                  style={{ verticalAlign: 'top' }}
                  target="_blank"
                  href={termsAndConditions}
                >
                  Terms and Conditions
                </a>
              </div>
              <div className="d-flex dt_step_Submit mt-4 p-0">
                <button
                  className="rounded-3 d-flex align-items-center justify-content-center fs-4 btn btn-light fw-medium me-2 p-4"
                  type="button"
                  onClick={() => onNextBtnClick(2)}
                >
                  <IoIosArrowBack customClass={'fs-2 text-black'} />
                  {/* Back */}
                </button>
                <button
                  type="button"
                  className={`rounded-3 flex-1 d-flex align-items-center justify-content-center fs-4 btn btn-secondary fw-medium ms-2 p-4 ${
                    selectedCoverPicture ? '' : 'disabled'
                  }`}
                  disabled={!selectedCoverPicture}
                  onClick={() =>
                    isChecked
                      ? registerChannel()
                      : toast.error('Please accept our terms and conditions')
                  }
                >
                  Submit
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </>
  );
};

export default memo(CoverImgSelectionForm);
